module.exports = __webpack_public_path__ + "img/symbol_3.3c00b82d.png";